import React, {useEffect, useState} from "react";
import {StackLayout} from "@progress/kendo-react-layout";
import {Button} from "@progress/kendo-react-buttons";
import {DateTime} from "luxon";
import {loadTodayStats} from "../services/historyService";
import {isFriday} from "../utils/date";
import {Quiz} from "../models/Quiz";

interface WelcomeScreenProps {
    /** undefined while today's quiz is loading; null when none exists. */
    quiz: Quiz | null | undefined;
    startPlaying: () => void;
    buttonClick: (requestedAction: () => void) => void;
}

export const WelcomeScreen = ({quiz, startPlaying, buttonClick}: WelcomeScreenProps) => {
    const fridayMode = isFriday();
    const isAnnounceOngoing = DateTime.now() <= DateTime.fromISO("2025-12-31");
    const [streak, setStreak] = useState(0);
    const [lapsToday, setLapsToday] = useState(0);

    const handleStart = () => {
        buttonClick(startPlaying);
    }

    useEffect(() => {
        const stats = loadTodayStats();
        setStreak(stats.daysInARow);
        setLapsToday(stats.lapsToday);
    }, []);

    return (
        <>
            <div className={'bg'} />
            <div className={'up'}>
                {/* The Furious Fridays mock-up (docs/FuriousFridaysMockup.png) uses the standard logo. */}
                <img className={'logo'} src={"./images/geard_logo.svg"} alt={"gEARED!!"}/>
                {fridayMode ?
                    <div className={'welcomeText'}>
                        <p className={'friday-headline em mb-1'}>FURIOUS FRIDAYS!!</p>
                        <p className={'friday mb-1'}>6 clips - 1 sec each</p>
                        <p>Full-length clips return tomorrow!!</p>
                    </div>
                    :
                    (isAnnounceOngoing ?
                        <div className={'welcomeText red'}>
                            <p>50+ new cars<br/>just added!!</p>
                        </div>
                        :
                        <div className={'welcomeText'}>
                            <p>6 new sounds every day.<br/>Come back tomorrow for more!!</p>
                        </div>)
                }

                <StackLayout orientation={"vertical"}>
                    <div className={'k-flex-20'} style={{marginTop: ".5rem"}}>
                        {quiz === null ?
                            <div className={'introText k-flex-30'}>
                                <p><strong>No quiz today — check back tomorrow!</strong></p>
                                {streak > 0 &&
                                    <p className={'streaks'}><strong>Streak: {streak}</strong></p>
                                }
                            </div>
                            :
                            <>
                                {/* Invisible (not absent) while loading so the layout doesn't jump when GO! appears. */}
                                <Button
                                    themeColor={'primary'}
                                    className={'start-button'}
                                    style={{fontSize: "xx-large", visibility: quiz === undefined ? 'hidden' : 'visible'}}
                                    disabled={quiz === undefined}
                                    onClick={handleStart}>GO!</Button>

                                {streak > 0 &&
                                    <p className={'streaks'}>
                                        {lapsToday > 0 &&
                                            <>
                                                {lapsToday} {lapsToday === 1 ? 'lap' : 'laps'} today<br/>
                                            </>
                                        }
                                        {streak} day streak!!</p>
                                }
                            </>
                        }
                        <div className={'welcomeText2 mt-4'}>
                            <p>gEAR’D!! is all about the sounds so please turn your<br/>VOLUME UP!!</p>
                        </div>
                    </div>
                </StackLayout>
            </div>
        </>
    );
};
